const onCadDownloadClick = (format) => {
    window.dataLayer = window.dataLayer || []
    const productName = document.querySelector('.npp__title--heading1').innerText
    window.dataLayer.push({
        event: 'download_content',
        content_type: 'cad',
        product_name: productName,
        file_format: format,
    })
}

export { onCadDownloadClick }
